<template>
  <div class="p-5"></div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisTest'] = this;
  }
}
</script>

<style lang="scss" scoped>
</style>